import React, { useEffect, useState } from "react";
import { thankyouIcon } from "../assets/images";
import { useNavigate, useParams } from "react-router-dom";
import { DownloadReceiptFile, GetOrderDetails, 
  // GetReceiptData 
} from "../api/common";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import { InvoiceDocument } from "./Invoice/InvoiceDocument";
// import { tostW } from "../config/tostConfig";
export default function PaymentSuccess() {
  const navigate = useNavigate();
  const {user_id} = useParams();
  const [data, setData] = useState({});
  const [receiptLoading, setReceiptLoading] = useState(false);
  // const [receiptData, setReceiptData] = useState({});

  const GetOrderData = async () =>{
    try {
      const res = await GetOrderDetails(user_id);
      if(res.status === 200 && res.data.success){
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // const GeReceiptData = async () => {
  //   setReceiptLoading(true);
  //   try {
  //     const res = await GetReceiptData(user_id);
  //     if(res.status === 200){
  //       setReceiptData(res.data);
  //       setReceiptLoading(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     tostW(error.message);
  //   }
  // }

  useEffect(() => {
    GetOrderData();
    // GeReceiptData();
  }, []) // eslint-disable-line

  const downloadReceipt = async () => {
    setReceiptLoading(true);
    try {
      const receipt = await DownloadReceiptFile(user_id);
      if (receipt.status === 200) {
        const receiptData = receipt.data; // Extract the data
  
        const blob = new Blob([receiptData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Receipt-${data.Unique_id}.pdf`;
        document.body.appendChild(link); // Append to the DOM (optional but safe)
        link.click();
        document.body.removeChild(link); // Remove from the DOM
        window.URL.revokeObjectURL(url); // Revoke URL to free up memory
      } else {
        throw new Error(`Failed to download receipt. Status: ${receipt.status}`);
      }
    } catch (error) {
      console.error("Error downloading receipt:", error.message || error);
    } finally {
      setReceiptLoading(false);
    }
  };

  return (
    <div className="customContainer thankyouPage headingTexts">
      <div className="thankyouDetails text-center">
        <div className="form-group">
          <img src={thankyouIcon} alt="" className="thankyouIcon" />
        </div>
        <h2>Payment Successful!</h2>
        <p style={{ fontWeight: "300" }}>
          Your payment was successful! You can now continue using EEMA
        </p>
        <p>
          <span>EMN Number : {data.Unique_id}</span>
        </p>
        <p>
          <span>Membership Type : {data.Plan_Name}</span>
        </p>
        <div>
          {/* {!receiptLoading ? 
          <PDFDownloadLink className="btn btn-primary me-3" document={<InvoiceDocument receipt={receiptData} />} fileName={`Invoice-${data.Unique_id}.pdf`}>
            {({ blob, url, loading, error }) => (
              loading ? "Loading..." : "Download Receipt" 
            )}
          </PDFDownloadLink>
          :<button className="btn btn-primary me-3" disabled>Download Receipt</button>} */}
          <button disabled={receiptLoading} className="btn btn-primary me-3" onClick={() => downloadReceipt()}>Download Receipt</button>
          <button
            onClick={() => {navigate("/", { replace: true })}}
            className="btn btn-primary"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}
